/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateDeviceRequest } from '../models/CreateDeviceRequest';
import type { CreateDeviceResponse } from '../models/CreateDeviceResponse';
import type { CreateInstitutionDepartmentRequest } from '../models/CreateInstitutionDepartmentRequest';
import type { CreateInstitutionDepartmentResponse } from '../models/CreateInstitutionDepartmentResponse';
import type { CreateInstitutionRequest } from '../models/CreateInstitutionRequest';
import type { CreateInstitutionResponse } from '../models/CreateInstitutionResponse';
import type { CreateTechnicalInspectionRequest } from '../models/CreateTechnicalInspectionRequest';
import type { DeviceSortBy } from '../models/DeviceSortBy';
import type { GetDeviceListResponse } from '../models/GetDeviceListResponse';
import type { GetDeviceResponse } from '../models/GetDeviceResponse';
import type { GetInstitutionActivitiesListResponse } from '../models/GetInstitutionActivitiesListResponse';
import type { GetInstitutionDepartmentListResponse } from '../models/GetInstitutionDepartmentListResponse';
import type { GetInstitutionDepartmentResponse } from '../models/GetInstitutionDepartmentResponse';
import type { GetInstitutionDepartmentUserListResponse } from '../models/GetInstitutionDepartmentUserListResponse';
import type { GetInstitutionHierarchyResponse } from '../models/GetInstitutionHierarchyResponse';
import type { GetInstitutionListResponse } from '../models/GetInstitutionListResponse';
import type { GetInstitutionResponse } from '../models/GetInstitutionResponse';
import type { GetInvestigationHierarchyResponse } from '../models/GetInvestigationHierarchyResponse';
import type { GetListTechnicalInspectionResponse } from '../models/GetListTechnicalInspectionResponse';
import type { GetMonitoringHierarchyResponse } from '../models/GetMonitoringHierarchyResponse';
import type { GetTechnicalInspectionResponse } from '../models/GetTechnicalInspectionResponse';
import type { InvestigationTypeModule } from '../models/InvestigationTypeModule';
import type { ListSortDirection } from '../models/ListSortDirection';
import type { MedicalAssistanceType } from '../models/MedicalAssistanceType';
import type { UpdateDeviceRequest } from '../models/UpdateDeviceRequest';
import type { UpdateDeviceResponse } from '../models/UpdateDeviceResponse';
import type { UpdateInstitutionDepartmentRequest } from '../models/UpdateInstitutionDepartmentRequest';
import type { UpdateInstitutionDepartmentResponse } from '../models/UpdateInstitutionDepartmentResponse';
import type { UpdateInstitutionNodeRequest } from '../models/UpdateInstitutionNodeRequest';
import type { UpdateInstitutionRequest } from '../models/UpdateInstitutionRequest';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class InstitutionService {
    /**
     * Updates an institution node.
     * Updates an institution node.
     * @param id
     * @param requestBody
     * @returns GetInstitutionResponse The institution has been updated successfully.
     * @throws ApiError
     */
    public static updateInstitutionNodeEndpoint(
        id: string,
        requestBody: UpdateInstitutionNodeRequest,
    ): CancelablePromise<GetInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/institutions/node/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution has not been found.`,
            },
        });
    }
    /**
     * Updates an intitution.
     * Updates an institution with provided details.
     * @param id Institution identifier.
     * @param requestBody
     * @returns GetInstitutionResponse The institution has been updated successfully.
     * @throws ApiError
     */
    public static updateInstitutionEndpoint(
        id: string,
        requestBody: UpdateInstitutionRequest,
    ): CancelablePromise<GetInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/institutions/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution has not been found.`,
            },
        });
    }
    /**
     * Gets an intitution.
     * Gets an institution with details.
     * @param id Institution identifier.
     * @returns GetInstitutionResponse The institution has been found.
     * @throws ApiError
     */
    public static getInstitutionEndpoint(
        id: string,
    ): CancelablePromise<GetInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution has not been found.`,
            },
        });
    }
    /**
     * Deletes a intitution.
     * Deletes a institution by its id.
     * @param id Institution identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteInstitutionEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/institutions/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution has not been found.`,
                409: `The institution has subordinate institutes.`,
            },
        });
    }
    /**
     * Gets a hierarchy of institutions.
     * Gets a 4-level hierarchy of institutions.
     * @param cuatmClassifierId
     * @param localityStatisticCode
     * @param declaresCases
     * @param tracksCases
     * @returns GetMonitoringHierarchyResponse The hierarchy of institutions has been found.
     * @throws ApiError
     */
    public static getMonitoringHierarchyEndpoint(
        cuatmClassifierId?: string | null,
        localityStatisticCode?: string | null,
        declaresCases?: boolean | null,
        tracksCases?: boolean | null,
    ): CancelablePromise<GetMonitoringHierarchyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/monitoring-localities-hierarchy',
            query: {
                'cuatmClassifierId': cuatmClassifierId,
                'localityStatisticCode': localityStatisticCode,
                'declaresCases': declaresCases,
                'tracksCases': tracksCases,
            },
            errors: {
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The hierarchy of institutions has not been found.`,
            },
        });
    }
    /**
     * Gets the investigation categories hierarchy for an institution.
     * Retrieves the investigation categories hierarchy for a specified institution, including parent-child relationships and associated investigation categories.
     * @param institutionId The unique identifier of the institution for which to retrieve the hierarchy.
     * @param module Gets or initializes the optional investigation type module filter.
     * @param specimenTypeIds Gets or initializes the collection of unique identifiers for specimens
     * associated with the investigation hierarchy.
     * This helps in filtering or associating specific specimens within a request.
     * @param isTb Optional tuberculosis (TB) filter. When true, only categories that contain a
     * TB-flagged investigation type are returned; when false, only categories with
     * non-TB types; when omitted, all categories are returned. Lets the frontend show TB
     * investigations in a separate block.
     * @returns GetInvestigationHierarchyResponse The investigation hierarchy has been successfully retrieved.
     * @throws ApiError
     */
    public static getInvestigationHierarchyEndpoint(
        institutionId: string,
        module?: InvestigationTypeModule | null,
        specimenTypeIds?: Array<string> | null,
        isTb?: boolean | null,
    ): CancelablePromise<GetInvestigationHierarchyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/{institutionId}/investigation-categories/hierarchy',
            path: {
                'institutionId': institutionId,
            },
            query: {
                'module': module,
                'specimenTypeIds': specimenTypeIds,
                'isTb': isTb,
            },
            errors: {
                400: `The request was invalid or missing required parameters.`,
                401: `User is not authorized to access this resource.`,
                404: `The institution or its parent could not be found.`,
            },
        });
    }
    /**
     * Updates a department.
     * Updates a department with provided details.
     * @param id Institution identifier.
     * @param departmentId Department identifier.
     * @param requestBody
     * @returns UpdateInstitutionDepartmentResponse The department has been updated successfully.
     * @throws ApiError
     */
    public static updateInstitutionDepartmentEndpoint(
        id: string,
        departmentId: string,
        requestBody: UpdateInstitutionDepartmentRequest,
    ): CancelablePromise<UpdateInstitutionDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/institutions/{id}/departments/{departmentId}',
            path: {
                'id': id,
                'departmentId': departmentId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution / department has not been found.`,
            },
        });
    }
    /**
     * Gets a department.
     * Gets a department with details.
     * @param id Institution identifier.
     * @param departmentId Department identifier.
     * @returns GetInstitutionDepartmentResponse Department has been retrieved successfully.
     * @throws ApiError
     */
    public static getInstitutionDepartmentEndpoint(
        id: string,
        departmentId: string,
    ): CancelablePromise<GetInstitutionDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/{id}/departments/{departmentId}',
            path: {
                'id': id,
                'departmentId': departmentId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution / department has not been found.`,
            },
        });
    }
    /**
     * Deletes a department.
     * Deletes a department from the institution.
     * @param id Institution identifier.
     * @param departmentId Department identifier.
     * @returns void
     * @throws ApiError
     */
    public static deleteInstitutionDepartmentEndpoint(
        id: string,
        departmentId: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/institutions/{id}/departments/{departmentId}',
            path: {
                'id': id,
                'departmentId': departmentId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution / department has not been found.`,
            },
        });
    }
    /**
     * Gets a list of users of the institution's department.
     * Gets a list of users of the institution's department.
     * @param id Institution identifier.
     * @param departmentId Department identifier.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @returns GetInstitutionDepartmentUserListResponse Users of the institution's department have been retrieved successfully.
     * @throws ApiError
     */
    public static getInstitutionDepartmentUserListEndpoint(
        id: string,
        departmentId: string,
        pageNumber: number = 1,
        pageSize: number = 10,
    ): CancelablePromise<GetInstitutionDepartmentUserListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/{id}/departments/{departmentId}/users',
            path: {
                'id': id,
                'departmentId': departmentId,
            },
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Gets a summary by department of the institution.
     * Gets the departments' user stats in the institution.
     * @param id Institution identifier.
     * @returns GetInstitutionDepartmentListResponse Departments have been retrieved successfully.
     * @throws ApiError
     */
    public static getInstitutionDepartmentListEndpoint(
        id: string,
    ): CancelablePromise<GetInstitutionDepartmentListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/{id}/departments',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates a department.
     * Creates a department within the institution.
     * @param id Institution identifier.
     * @param requestBody
     * @returns CreateInstitutionDepartmentResponse The institution department has been created successfully.
     * @throws ApiError
     */
    public static createInstitutionDepartmentEndpoint(
        id: string,
        requestBody: CreateInstitutionDepartmentRequest,
    ): CancelablePromise<CreateInstitutionDepartmentResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/institutions/{id}/departments',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution has not been found.`,
            },
        });
    }
    /**
     * Gets a hierarchy of institutions.
     * Gets a 4-level hierarchy of institutions.
     * @param parentId
     * @param declaresCases
     * @param tracksCases
     * @param medicalAssistanceTypes
     * @param roleIds
     * @param maxDepth
     * @returns GetInstitutionHierarchyResponse The hierarchy of institutions has been found.
     * @throws ApiError
     */
    public static getInstitutionHierarchyEndpoint(
        parentId?: string | null,
        declaresCases?: boolean | null,
        tracksCases?: boolean | null,
        medicalAssistanceTypes?: Array<MedicalAssistanceType> | null,
        roleIds?: Array<string> | null,
        maxDepth: number = 10,
    ): CancelablePromise<GetInstitutionHierarchyResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions/hierarchy',
            query: {
                'parentId': parentId,
                'declaresCases': declaresCases,
                'tracksCases': tracksCases,
                'medicalAssistanceTypes': medicalAssistanceTypes,
                'roleIds': roleIds,
                'maxDepth': maxDepth,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The hierarchy of institutions has not been found.`,
            },
        });
    }
    /**
     * Gets a list of institutions.
     * Gets a list of institutions.
     * @param pageNumber Page number.
     * @param pageSize Page size.
     * @param institutionCode
     * @param searchTerm Search by the institution name.
     * @param institutionTypeId Filter by the institution type.
     * @returns GetInstitutionListResponse The institution list has been found.
     * @throws ApiError
     */
    public static getInstitutionListEndpoint(
        pageNumber: number = 1,
        pageSize: number = 10,
        institutionCode?: string | null,
        searchTerm?: string | null,
        institutionTypeId?: string | null,
    ): CancelablePromise<GetInstitutionListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institutions',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'institutionCode': institutionCode,
                'searchTerm': searchTerm,
                'institutionTypeId': institutionTypeId,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates an intitution.
     * Creates an institution without details.
     * @param requestBody
     * @returns CreateInstitutionResponse The institution has been created successfully.
     * @throws ApiError
     */
    public static createInstitutionEndpoint(
        requestBody: CreateInstitutionRequest,
    ): CancelablePromise<CreateInstitutionResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/institutions',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                409: `The root institution already exists.`,
            },
        });
    }
    /**
     * Updates a device.
     * Updates a device with provided details.
     * @param id Gets the unique identifier of the device.
     * @param requestBody
     * @returns UpdateDeviceResponse The device has been updated successfully.
     * @throws ApiError
     */
    public static updateDeviceEndpoint(
        id: string,
        requestBody: UpdateDeviceRequest,
    ): CancelablePromise<UpdateDeviceResponse> {
        return __request(OpenAPI, {
            method: 'PUT',
            url: '/api/devices/{id}',
            path: {
                'id': id,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The device has not been found.`,
                409: `The device with the same code already exists.`,
            },
        });
    }
    /**
     * Gets a device.
     * Gets a device with details.
     * @param id Gets or initializes the unique identifier of the device to retrieve.
     * @returns GetDeviceResponse The device has been retrieved successfully.
     * @throws ApiError
     */
    public static getDeviceEndpoint(
        id: string,
    ): CancelablePromise<GetDeviceResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/devices/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The device has not been found.`,
            },
        });
    }
    /**
     * Deletes a device.
     * Deletes a device.
     * @param id Gets or initializes the unique identifier of the device to be deleted.
     * @returns void
     * @throws ApiError
     */
    public static deleteDeviceEndpoint(
        id: string,
    ): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/devices/{id}',
            path: {
                'id': id,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The device has not been found.`,
            },
        });
    }
    /**
     * Retrieves a paginated list of technical inspections.
     * This endpoint requires the following permissions: [ OrganizationalStructure.OrganizationalStructure.View.Device ]
     * @param pageNumber Gets or initializes the page number for the request. Defaults to 1.
     * @param pageSize Gets or initializes the page size for the request. Defaults to 10.
     * @param institutionsIds Gets or initializes the array of legal entity IDs to filter the inspections.
     * @param deviceIds Gets or initializes the array of device IDs to filter the inspections.
     * @param executionDateFrom Gets or initializes the execution starting date for filtering inspections.
     * @param executionDateTo Gets or initializes the execution ending date for filtering inspections.
     * @returns GetListTechnicalInspectionResponse A list of technical inspections has been successfully retrieved.
     * @throws ApiError
     */
    public static getListTechnicalInspectionEndpoint(
        pageNumber: number,
        pageSize: number,
        institutionsIds: Array<string>,
        deviceIds: Array<string>,
        executionDateFrom?: string | null,
        executionDateTo?: string | null,
    ): CancelablePromise<GetListTechnicalInspectionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/devices/technical-inspections',
            query: {
                'pageNumber': pageNumber,
                'pageSize': pageSize,
                'institutionsIds': institutionsIds,
                'deviceIds': deviceIds,
                'executionDateFrom': executionDateFrom,
                'executionDateTo': executionDateTo,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Retrieves a specific technical inspection.
     * This endpoint requires the following permissions: [ OrganizationalStructure.OrganizationalStructure.View.Device ]
     * @param inspectionId Gets or initializes the unique identifier of the technical inspection.
     * @returns GetTechnicalInspectionResponse The technical inspection has been retrieved successfully.
     * @throws ApiError
     */
    public static getTechnicalInspectionEndpoint(
        inspectionId: string,
    ): CancelablePromise<GetTechnicalInspectionResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/devices/technical-inspections/{inspectionId}',
            path: {
                'inspectionId': inspectionId,
            },
            errors: {
                400: `Bad Request`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The specified technical inspection was not found.`,
            },
        });
    }
    /**
     * Creates a technical inspection.
     * This endpoint requires the following permissions: [ OrganizationalStructure.OrganizationalStructure.Update.Device ]
     * @param deviceId Gets or initializes the unique identifier of the device to be inspected.
     * @param requestBody
     * @returns any The technical inspection has been created successfully.
     * @throws ApiError
     */
    public static createTechnicalInspectionEndpoint(
        deviceId: string,
        requestBody: CreateTechnicalInspectionRequest,
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/devices/{deviceId}/technical-inspections',
            path: {
                'deviceId': deviceId,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The institution or device was not found.`,
            },
        });
    }
    /**
     * Gets a list of devices.
     * Gets a list of devices within the institution.
     * @param institutionsIds Optional array of institution IDs to filter devices by their associated institutions.
     * @param pageNumber Page number for pagination, defaults to 1.
     * @param pageSize Number of items per page, defaults to 10.
     * @param searchTerm Optional search term to filter devices by text match.
     * @param sortBy Optional field to sort the device list by.
     * @param sortDirection Optional sort direction (ascending or descending).
     * @param date Optional date to filter devices.
     * @returns GetDeviceListResponse Devices have been retrieved successfully.
     * @throws ApiError
     */
    public static getDeviceListEndpoint(
        institutionsIds: Array<string>,
        pageNumber: number,
        pageSize: number,
        searchTerm?: string | null,
        sortBy?: DeviceSortBy | null,
        sortDirection?: ListSortDirection | null,
        date?: string | null,
    ): CancelablePromise<GetDeviceListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/devices',
            query: {
                'institutionsIds': institutionsIds,
                'searchTerm': searchTerm,
                'sortBy': sortBy,
                'sortDirection': sortDirection,
                'date': date,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
    /**
     * Creates a device.
     * Creates a device.
     * @param requestBody
     * @returns CreateDeviceResponse The device has been created successfully.
     * @throws ApiError
     */
    public static createDeviceEndpoint(
        requestBody: CreateDeviceRequest,
    ): CancelablePromise<CreateDeviceResponse> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/devices',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
                404: `The device has not been found.`,
                409: `The device with the same code already exists.`,
            },
        });
    }
    /**
     * Institution messages list.
     * Gets the list of registered messages for user institution.
     * @param pageNumber
     * @param pageSize
     * @param userId
     * @param roleId
     * @param searchTerm
     * @param traceId
     * @param fromDate
     * @param toDate
     * @returns GetInstitutionActivitiesListResponse The list has been found.
     * @throws ApiError
     */
    public static getInstitutionActivitiesListEndpoint(
        pageNumber: number,
        pageSize: number,
        userId?: string | null,
        roleId?: string | null,
        searchTerm?: string | null,
        traceId?: string | null,
        fromDate?: string | null,
        toDate?: string | null,
    ): CancelablePromise<GetInstitutionActivitiesListResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/institution/activities',
            query: {
                'userId': userId,
                'roleId': roleId,
                'searchTerm': searchTerm,
                'traceId': traceId,
                'fromDate': fromDate,
                'toDate': toDate,
                'pageNumber': pageNumber,
                'pageSize': pageSize,
            },
            errors: {
                400: `The required parameters were not provided.`,
                401: `User is not authorized.`,
                403: `Forbidden`,
            },
        });
    }
}
